require("./style.css");
import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import { Link } from "react-router-dom";

import VerticalBarChart from "./VerticalBarChart";
import PieChartHighlight from "./PieChartHighlight";
import map from "lodash/map";
class SegmentDetailReport extends AcquireWebComponent {
  render() {
    const { style, data, printTitle } = this.props;
    const urls = window.location.href.split("?");
    if (this.props.loading)
      return (
        <div
          className="text-center"
          style={{ marginTop: "50px", marginBottom: "40px" }}
        >
          <img alt="" src="/Spinner.gif" style={{ height: "48px" }} />
        </div>
      );
    return (
      <div>
        <div
          style={{
            display: "none",
            padding: "20px",
            background: "#D9DBDD",
            color: "#000",
            fontWeight: "bold",
            marginTop: "20px",
          }}
          className="pdf-extra-container"
        >
          {printTitle}
        </div>
        <div style={style} className="segment-detail-container">
          <div style={{ flex: "100%" }}>
            <div className="light-grey-border mb-20">
              {data &&
                data.state && [
                  <PieChartHighlight
                    key="1"
                    data={data.state.values}
                    title={"Top States"}
                    dataKey="value"
                    fieldTitle="Unique Visitors"
                    showList={true}
                    showDetail={true}
                    showPercentage={true}
                  />,
                  <div className="ml-20 mb-5 nav-clickable" key="2">
                    <Link
                      to={"/segment-distribution?" + urls[1] + "&heatmap=true"}
                    >
                      View on map
                    </Link>
                  </div>,
                ]}
            </div>
            <div className="light-grey-border">
              {data && data.maritalStatus && (
                <PieChartHighlight
                  data={data.maritalStatus.values}
                  showHeader={false}
                  showHighlight={true}
                  title={"Marital Status"}
                  dataKey="value"
                  showDetail={true}
                  fieldTitle={""}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SegmentDetailReport;



// WEBPACK FOOTER //
// ./src/components/Insights/distribution/SegmentDetailReport.js